import type { PortalTheme } from '@/schema/gift-portal.schema'
import type { PortalTranslations } from '../../i18n'
import { portalCssVars, PORTAL_CSS } from '../portal-styles'
import { LangToggle } from '../lang-toggle'

interface ValidatePageProps {
  error?: string
  theme: PortalTheme
  customerName?: string
  preview?: boolean
  translations: PortalTranslations
  lang: string
  allTranslations?: Record<string, PortalTranslations>
  languages?: string[]
  csrfToken?: string
}

export function ValidatePage({
  error,
  theme,
  customerName,
  preview,
  translations: t,
  lang,
  allTranslations,
  languages,
  csrfToken,
}: ValidatePageProps) {
  return (
    <div className="portal-theme portal-page">
      <style>
        {portalCssVars(theme, { standalone: !preview }) + '\n' + PORTAL_CSS}
      </style>

      {!preview && allTranslations && languages && (
        <LangToggle
          lang={lang}
          allTranslations={allTranslations}
          languages={languages}
        />
      )}

      <div className="portal-card">
        {theme.logoUrl && (
          <img src={theme.logoUrl} alt="Logo" className="portal-logo" />
        )}

        <h1 className="portal-title" data-i18n="validate.title">
          {t.validate.title}
        </h1>
        <p className="portal-text" data-i18n="validate.subtitle">
          {t.validate.subtitle}
        </p>

        {error && <div className="portal-alert">{error}</div>}

        <form
          method="POST"
          action={
            customerName
              ? `/${customerName}/gift-portal/validate`
              : '/gift-portal/validate'
          }
          className="portal-form"
        >
          <input type="hidden" name="lang" value={lang} />
          {csrfToken && <input type="hidden" name="_csrf" value={csrfToken} />}

          <label className="portal-label">
            <span data-i18n="validate.cardNumber">{t.validate.cardNumber}</span>
            <input
              type="text"
              name="cardNumber"
              required
              autoFocus
              className="portal-input"
              placeholder={t.validate.cardPlaceholder}
              data-i18n="validate.cardPlaceholder"
            />
          </label>

          <label className="portal-label">
            <span data-i18n="validate.pin">{t.validate.pin}</span>
            <input
              type="text"
              name="pinCode"
              required
              className="portal-input"
              placeholder={t.validate.pinPlaceholder}
              data-i18n="validate.pinPlaceholder"
            />
          </label>

          <button
            type="submit"
            className="portal-btn"
            data-i18n="validate.continue"
          >
            {t.validate.continue}
          </button>
        </form>
      </div>
    </div>
  )
}

ValidatePage.displayName = 'ValidatePage'
